import { axios } from "../axios.instance";

export type BlockUserRequest = {
  userId: string;
};

export type BlockUserResponse = object;

export const blockUser = async (body: BlockUserRequest): Promise<BlockUserResponse> => {
  const { data } = await axios.post(`/blocks/${body.userId}/block`);

  return data;
};
